import { element_exists, redesignDataTablesHeader } from "../functions";
import {
  addSelectedCompanyHandler,
  companyGuard,
  fnErrorMsg,
  fnToastrFormError,
  pjaxRedirect,
  printResponse,
  resetForm,
} from "../jquery-functions-library";
import moment from "moment";
import AutoNumeric from "autonumeric";

export var fnPayrollActivityDataTable = function() {
  const tableId = "#datatable-payroll-activity-log";
  const $table = $(tableId);

  $("#selected_company").on("change", function() {
    setTimeout(() => {
      window.location.reload();
    }, 500);
  });

  if (companyGuard()) {
    $("#display-select-client").removeClass("hidden");
    $(tableId)
      .parents(".datatable-responsive")
      .addClass("hidden");
    if (typeof contentColumn !== "undefined") {
      $(contentColumn).addClass("hidden");
    }
    $(tableId)
      .DataTable()
      .clear()
      .draw();
    return;
  }

  const columns = [
    {
      data: "date",
      render(data) {
        return data ? moment(data).format("DD/MM/YYYY H:mm:ss") : "";
      },
    },
    { data: "subject" },
    { data: "user" },
    { data: "description" },
    {
      data: "content",
      render(data) {
        let json = data ? data : null;

        if (json) {
          json = json.replaceAll(/&quot;/g, '"');
          json = JSON.parse(json);
          let content = "";
          Object.keys(json).forEach(function(key) {
            if (typeof json[key] === "object") {
              return;
            }
            content += `<b>${key}:</b> ${json[key]}<br>`;
          });

          return content;
        } else {
          return "";
        }
      },
    },
  ];

  const table = $table.DataTable({
    language: allLangFiles.datatables,
    rowId: "id",
    ajax: {
      url: `/payrolls/activity-log`,
      dataSrc: function(json) {
        $.fn.dataTable.moment("DD/MM/YYYY H:mm:ss");
        return json.data;
      },
    },
    order: [[0, "desc"]],
    columns,
  });
};
